// Animation timing constants - SINGLE SOURCE OF TRUTH
// All animation timing should reference these constants

/**
 * Target animation frame rate for smooth playback
 */
export const ANIMATION_FPS = 20;

/**
 * Time spacing between animation frames in seconds
 * This determines the temporal resolution of all animations
 */
export const ANIMATION_TIME_STEP = 1 / ANIMATION_FPS; // 0.05 seconds

/**
 * Visual update interval in milliseconds
 * Derived from data temporal resolution to ensure consistent frame rate
 * regardless of section duration
 */
export const VISUAL_UPDATE_INTERVAL_MS = ANIMATION_TIME_STEP * 1000; // 50ms (20fps)
